module.exports = __webpack_public_path__ + "static/img/6.5a88619e.jpg";